import Dropdown from '../../components/Dropdown/Dropdown.jsx';
import ResetSvg from '../../assets/svg/ResetSvg.jsx';
import './Filter.scss';
import { useEffect, useMemo, useRef, useState } from 'react';
import gsap from 'gsap';

function Filter({ setPage, universes, rares, filters, setFilters }) {
    const [isClicked, setIsClicked] = useState(false);
    const resetRef = useRef(null);

    useEffect(() => {
        if (isClicked) {
            gsap.fromTo(resetRef.current, {scale: 1}, {
                scale: .96,
                duration: 0.2,
                ease: "power2.out",
                onComplete: () => setIsClicked(false),
            })
        } else {
            gsap.to(resetRef.current, {
                scale: 1,
                duration: 0.1,
                ease: "power2.in",
            })
        }
    }, [isClicked])

    const onResetFilters = () => {
        setPage(1)
        setIsClicked(true)
        setFilters(prev => ({...prev, universe: null, rare: null}))
    }
    
     const universesOptions = useMemo(() => {
        const arr = [{type: "universes", value: null, label: "-"}];
        universes.forEach(universe => {
            if (!arr.some(item => item.value === universe.universe || universe.universe === "Unknown")) {
                arr.push({type: "universes", value: universe.universe, label: universe.universe_name})
            }
        })

        return arr
    }, [universes])

    const raresOptions = useMemo(() => {
        const arr = [{type: "rares", value: null, label: "-"}];
        rares.forEach(rare => {
            if (!arr.some(item => item.value === rare || rare === "Unknown")) {
                arr.push({type: "rares", value: rare, label: rare})
            }
        })

        return arr
    }, [rares])

    return (
        <div className='filter-wrapper'>
            <span className='filter-title'>Фильтры</span>

            <div className='filter-dropdowns'>
                <div className='filter-one-dropdown'>
                    <Dropdown
                        options={universesOptions}
                        filters={filters}
                        setFilters={setFilters}
                        label={"Вселенная"}
                    />
                </div>

                <div className='filter-one-dropdown'>
                    <Dropdown
                        options={raresOptions}
                        filters={filters}
                        setFilters={setFilters}
                        label={"Редкость"}
                    />
                </div>
            </div>

            <div className='reset-filter-button' ref={resetRef}>
                <ResetSvg />
                <div onClick={onResetFilters}>Сбросить фильтры</div>
            </div>
        </div>
    )
}

export default Filter;